"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orgClub = void 0;
exports.orgClub = {
    id: 26369,
    name: 'Club Organization',
};
